<div class="modal-header">
  <div class="modal-branding-content">
    <span class="modal-header-branding-text">Download the Latest Electrical Standards</span>
  </div>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss(false)">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body py-2 electrical-standards-modal-body">
  <div class="electrical-standards-modal__search">
    <div class="input-group">
      <input
        type="text"
        class="form-control m-input"
        placeholder="Search..."
        [(ngModel)]="searchTerm"
        name="searchTerm"
        (ngModelChange)="onSearchTermChanged()"
        (keyup.enter)="loadStandards(true)"
      />
      <span class="input-group-btn">
        <button class="btn btn-primary" type="button" (click)="loadStandards(true)" [disabled]="searchLoading || isLoading">
          <i class="flaticon-search-1" *ngIf="!(searchLoading || isLoading)" aria-label="Search"></i>
          <i class="fa fa-spinner fa-spin" *ngIf="searchLoading || isLoading"></i>
        </button>
      </span>
    </div>
  </div>

  <div *ngIf="isLoading && standards.length === 0" class="text-center py-4">
    <i class="fa fa-spinner fa-spin me-2"></i>
    <span class="ms-2">Loading...</span>
  </div>

  <div *ngIf="!isLoading && hasError" class="alert alert-danger mt-2">
    {{ errorMessage }}
  </div>

  <div *ngIf="!isLoading && !hasError && standardsPaginationConfig.totalItems === 0" class="text-muted text-center py-4">
    No standards found.
  </div>

  <div class="electrical-standards-modal__list p-3" *ngIf="standardsPaginationConfig.totalItems > 0">
    <div *ngFor="let standard of standards | paginate: standardsPaginationConfig" class="standard-item">
      <div class="standard-item__row">
        <div class="standard-item__content">
          <div class="standard-item__title-line">
            <strong class="standard-item__title">{{ standard.title }}</strong>
            <span *ngIf="getStatusLabel(standard.statusTag) as statusLabel"
                  class="status-tag"
                  [ngClass]="getStatusTagClass(standard.statusTag)">
              {{ statusLabel }}
            </span>
          </div>
          <p class="standard-item__description text-muted" *ngIf="standard.description">
            {{ standard.description }}
          </p>
        </div>

        <div class="standard-item__actions">
          <a href="javascript:void(0)"
             (click)="getStandardUrl(standard.id)"
             rel="noopener noreferrer"
             class="standard-item__link text-decoration-none fw-semibold"
             [class.is-loading]="openingId === standard.id">
            <i class="fa fa-file-pdf-o me-1" *ngIf="openingId !== standard.id"></i>
            <i class="fa fa-spinner fa-spin me-1" *ngIf="openingId === standard.id"></i>
            View PDF
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="electrical-standards-modal__pagination mb-4" *ngIf="standardsPaginationConfig.totalItems > 0">
    <pagination-controls
      id="{{ standardsPaginationConfig.id }}"
      (pageChange)="standardsPageChanged($event)">
    </pagination-controls>
  </div>
</div>
